/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-table (useAsyncDebounce) trae del build de npm código transpilado con
// generators que espera un regeneratorRuntime global. CRA lo resolvía por su
// cuenta vía babel-preset-react-app; Vite no lo provee, hay que polyfillearlo.
import "regenerator-runtime/runtime"
import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "App"
import { getBasename } from "appBasePath"

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context"
import NotificationProvider from "context/NotificationContext"

const container = document.getElementById("app")
const root = createRoot(container)

root.render(
  <BrowserRouter basename={getBasename() || undefined}>
    <MaterialUIControllerProvider>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
)
